import { EthAddress } from '@xylabs/sdk-js'
import { XyoNetworkWrapper } from '@xyo-network/sdk-xyoworld-js'
import { PropsWithChildren } from 'react'

import { NetworkSettingsContext } from './Context'

const loadNetworks = () => {
  const networks = new Map<number, XyoNetworkWrapper>()

  const localhost = new XyoNetworkWrapper(5777)
  networks.set(5777, localhost)

  /*const kovan = new XyoNetworkWrapper('kovan')
  kovan.addresses.currency = '0x69CB6C8534d4FCA678093C5Ad442dFD7509E349c'
  kovan.addresses.geotokens = '0xd6336BE9079c62dC550AC3f239399Af80191deDB'
  kovan.addresses.minter = '0x50FD4b79997F6a619c6Cd91E72f5B4dF2cC3eC1b'
  kovan.save()
  networks.set('kovan', kovan)*/

  //fhr address: 0x2733374D5763a124aF8c4abAC4f5ec69f61a1CD5
  const main = new XyoNetworkWrapper(1)
  main.addresses.currency = EthAddress.fromString('0x55296f69f40ea6d20e478533c15a6b08b654e758')
  main.addresses.geotokens = EthAddress.fromString('0x85773C1d866C89CA0b7C700F27e95a028A46B9E3')
  main.addresses.minter = EthAddress.fromString('0xa23C7a1Ef71A717f6aAa3Ad0FbF168d500dA7C30')
  main.addresses.geotokens_v1 = EthAddress.fromString('0x9fc672F00B0ef186Baf15152f88BB41dd366C08F')
  main.addresses.geotokens_v2 = EthAddress.fromString('0x11362C78daDB0c10a5C2cE2331F30D2282830Df0')
  main.addresses.minter_v1 = EthAddress.fromString('0x7EE68fDF38381Ea4Ec1C1F067fAa70d688dC484a')
  main.addresses.minter_v2 = EthAddress.fromString('0x1938FfCBD6B8Dd17BFF5bF1aCA1e0512f00C2c3e')
  //main.save()
  networks.set(1, main)

  return networks
}

interface Props {
  enabled?: boolean
}

export const NetworkSettingsLoader: React.FC<PropsWithChildren<Props>> = (props) => {
  const { children } = props

  const networks = loadNetworks()

  return <NetworkSettingsContext.Provider value={networks}>{children}</NetworkSettingsContext.Provider>
}
